// extracted by mini-css-extract-plugin
export var container = "style-module--container--30392";
export var graduate = "style-module--graduate--b7294";
export var info = "style-module--info--ce372";